import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M15.1 19.247a.75.75 0 0 1-.75-.75v-4.252h-1.5v4.252a2.25 2.25 0 0 0 2.25 2.25h3.4a2.25 2.25 0 0 0 2.25-2.25v-13a2.25 2.25 0 0 0-2.25-2.25h-3.4a2.25 2.25 0 0 0-2.25 2.25v4.248h1.5V5.496a.75.75 0 0 1 .75-.75h3.4a.75.75 0 0 1 .75.75v13.001a.75.75 0 0 1-.75.75zM3.25 11.998c0 .216.092.411.238.548l4.607 4.61a.75.75 0 0 0 1.06-1.06l-3.344-3.348h10.19a.75.75 0 1 0 0-1.5H5.815l3.34-3.342a.75.75 0 0 0-1.06-1.06L3.523 11.42a.75.75 0 0 0-.272.578",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }